exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ai-html-preview-wrapper{display:flex;background-size:contain;background-position:50%;background-repeat:no-repeat;flex-direction:column-reverse}.ai-html-preview-wrapper.portrait{background-image:url(" + require("../../../../images/new-preview-background-portraite.jpeg") + ")}.ai-html-preview-wrapper.landscape{background-image:url(" + require("../../../../images/ai-preview/BG_Landscape_1920x1080.jpg") + ");position:relative}.ai-html-preview-wrapper.landscape .persona{width:100%;height:100%}.ai-html-preview-wrapper.landscape #ageSlider{position:absolute;width:auto;left:0;right:0}.ai-html-preview-wrapper #ageSlider{width:90%;margin:0 auto;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/ai-html-preview/ai-html-preview.scss
// module id = 836
// module chunks = 0